import requests from './httpService';

const IconMasterService = {
  getAllIconMaster(body) {
    return requests.post(`/iconmaster/list`, body);
  },
  
  findIconMasterList(body) {
    return requests.post(`/iconmaster/find`, body);
  },
  
  createIconMaster(body) {
    return requests.post('/iconmaster/add', body);
  },
  
  getIconMasterById(id) {
    return requests.get(`/iconmaster/${id}`);
  },
  
  updateIconMaster(id, body) {
    return requests.put(`/iconmaster/${id}`, body);
  },
  
  deleteIconMaster(id) {
    return requests.delete(`/iconmaster/${id}`);
  },

  uploadImage(body) {
    return requests.post('/iconmaster/uploadimage', body);
  },

  deleteAzureImage(body) {
    return requests.post('/iconmaster/deleteimage', body);
  },
};

export default IconMasterService;

